import { Link, List, Toolbar } from "@mui/material";
import NavItem from "./NavItem";
import { drawerCloseWidth, drawerOpenWidth } from "..";
import logoWithText from "../../../assets/logo.png";
import logo from "../../../assets/logo.png";
import navItems from "../../../data/nav-items";
import Image from "../../../components/base/Image";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { useAuthState } from "../../../context/AuthContext";

const Sidebar = ({ open }) => {
  const { userRole } = useAuthState();
  return (
    <>
      <Toolbar
        sx={{
          position: "fixed",
          height: 98,
          zIndex: 1,
          bgcolor: "background.default",
          p: 0,
          justifyContent: "center",
          width: open ? drawerOpenWidth - 1 : drawerCloseWidth - 1,
        }}
      >
        <Link
          href="/"
          sx={{
            mt: 3,
          }}
        >
          <Image
            src={open ? logoWithText : logo}
            alt={open ? "logo with text" : "logo"}
            height={40}
          />
        </Link>
      </Toolbar>

      <SimpleBar style={{ maxHeight: "100vh" }}>
        <List
          component="nav"
          sx={{
            mt: 24.5,
            py: 2.5,
            height: 724,
            justifyContent: "space-between",
          }}
        >
          {navItems.map((item) => (
            <NavItem
              key={item.path}
              navItem={item}
              open={open}
              currentRole={userRole}
            />
          ))}
        </List>
      </SimpleBar>
    </>
  );
};

export default Sidebar;
